import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-freeze-sotr',
  standalone: false,
  templateUrl: './freeze-sotr.component.html',
  styleUrl: './freeze-sotr.component.scss'
})
export class FreezeSOTRComponent implements OnInit {
  @Output() stepCompleted = new EventEmitter<void>();
  freezeSotrData: any
  // any[] = 
  // [
  //   {
  //     file_name: 'Freeze SOTR-1',
  //     file_number: '12345678888890',
  //     document: 'assets/images/pdf.png',
  //     file_status: 1
  //   },
  //   {
  //     file_name: 'Freeze SOTR-2',
  //     file_number: '1234567',
  //     document: 'assets/images/pdf.png',
  //     file_status: 1
  //   },
  //   {
  //     file_name: 'Freeze SOTR-3',
  //     file_number: '1234567890',
  //     document: 'assets/images/pdf.png',
  //     file_status: 1
  //   }
  // ];

  selectedProduct: any;
  apiUrl = environment.APIUrl;
  @Input() step: any;
  @Input() getUrl: string;
  @Input() postUrl: string;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  @Output() IRA: EventEmitter<any> = new EventEmitter<any>();
  payload: { proposal_id: any; proposal_name: any; };
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  userID: any;
  constructor(private route: ActivatedRoute, private api: ApiService, private messageService: MessageService,) {
      const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName
      };
    });
    this.getDetails();
  }

  goToNextStep() {
    this.stepCompleted.emit();
  }
  freeze() {
    // console.log(this.selectedProduct)
    let payload = {
      sotr_status: 2
    }
    this.api.putAPI(`/revenue/need/version-control/${this.selectedProduct.id}/`, payload).subscribe((res: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'SOTR freezed successfully' });
      //  this.stepCompleted.emit(); 
      this.getDetails()
    });
  }


  getFileName(url: string): string {
    return url.split('/').pop() || 'Unknown File';
  }
  getDetails() {
    this.api.getAPI(`/revenue/need/version-control/?proposal_step__proposal=${this.payload.proposal_id}`)
      .subscribe((res: any) => {
        this.freezeSotrData = [...res]
        this.selectedProduct = this.freezeSotrData.find(item => item.sotr_status === 2);
      });
  }
  openPrintWindow(htmlContent: string) {
    const printWindow = window.open('', '_blank', 'width=900,height=700');

    if (printWindow) {
      const doc = printWindow.document;
      doc.open();
      doc.write(`
      <html>
        <head>
          <title>Document Preview</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            table { border-collapse: collapse; width: 100%; }
            table, th, td { border: 1px solid black; }
            th, td { padding: 8px; text-align: left; }
          </style>
        </head>
        <body>
          <h2>Document Preview</h2>
          <div id="print-section">
            ${htmlContent}
          </div>
          <!-- Print button removed -->
        </body>
      </html>
    `);
      doc.close();
    }
  }


}